import { format, isValid } from "date-fns";

// One on-screen date style for the whole app — day first, the way Indian clinics write dates.
// The printed prescription, invoice and discharge summary use it too.

type DateInput = string | number | Date | null | undefined;

function toDate(value: DateInput): Date | null {
  if (value == null || value === "") return null;
  // A bare "YYYY-MM-DD" is a calendar date: read it as local midnight, not UTC
  const d = typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)
    ? new Date(`${value}T00:00:00`)
    : new Date(value);
  return isValid(d) ? d : null;
}

/** "29 Sep 2026" */
export function formatDate(value: DateInput): string {
  const d = toDate(value);
  return d ? format(d, "dd MMM yyyy") : "";
}

/** "29 Sep" */
export function formatShortDate(value: DateInput): string {
  const d = toDate(value);
  return d ? format(d, "dd MMM") : "";
}

/** "5:32 PM" */
export function formatTime(value: DateInput): string {
  const d = toDate(value);
  return d ? format(d, "h:mm a") : "";
}

/** A wait or consultation length: "22 min", "1 h 5 min" — one format on every screen */
export function formatWait(mins: number): string {
  return mins < 60 ? `${mins} min` : `${Math.floor(mins / 60)} h${mins % 60 ? ` ${mins % 60} min` : ''}`;
}

/** "29 Sep 2026, 5:32 PM" */
export function formatDateTime(value: DateInput): string {
  const d = toDate(value);
  return d ? format(d, "dd MMM yyyy, h:mm a") : "";
}
